var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPickaxe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e0b32d;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wK3Lcy.tif"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M189.24,815.1c3.84-15.86,13.16-28.06,24.56-39.43Q399.34,590.6,584.52,405.18c6.58-6.58,6.67-6.66,13.46-.55a1032.66,1032.66,0,0,1,76.89,76.87c6.26,7,6.18,7.05-.25,13.48C550,619.65,424.84,743.86,300.9,869.24c-37.72,38.16-96.8,22.43-110.64-27a21.93,21.93,0,0,0-1-2.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M484.94,189.49c17.82,2.39,35.66,4.59,53.22,8.66,66.68,15.44,125.39,46.73,177.74,90.22C773.08,335.87,820.34,391.53,852.57,459c20.11,42.14,32.91,86.38,36.76,133.08,3.08,37.33,1.56,74.27-8.47,110.55-3,10.65-11.44,17.17-21.32,16.94-9.46-.22-18-6.7-19.95-15.82-1.28-6-1.41-12.23-2.53-18.27-7.6-41.21-25.16-78.47-46.27-114.17C753.34,508,705.55,453.05,653,402c-47-45.62-97.51-86.7-154.74-119-32.32-18.21-66-33.29-102.72-40.31-5.14-1-10.37-1.53-15.57-2.1-10.93-1.21-18.8-8.82-19.79-19.31-.92-9.72,5.52-19.13,15.67-22.23,14.43-4.41,29.32-6.63,44.25-8.56,2-.26,4-.69,6-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M784.66,228.94c27.23,0,51.89,16.87,61.38,40.78a63.59,63.59,0,0,1-15.68,69.64c-3.23,3.08-5.25,3.3-8.18-.28a579.15,579.15,0,0,0-81.48-81.52c-3.42-2.81-3.81-4.8-.54-8.15C752.89,236.36,768.27,229.63,784.66,228.94Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPickaxe);
export default __webpack_public_path__ + "static/media/pickaxe.ac8c843398d54906f9a187eb3eec60ea.svg";
export { ForwardRef as ReactComponent };